type SidebarPagesNames = 'promo' | 'jackpots' | 'tournaments' | 'loyalty';

export type SidebarPagesParams = {
  path: string;
  title: string;
  highlighted?: boolean;
  new?: boolean;
};

const SIDEBAR_PAGES: Record<SidebarPagesNames, SidebarPagesParams> = {
  promo: {
    path: '/bonuses',
    title: 'sidebarPages.promo',
    highlighted: true
  },
  jackpots: {
    path: '/jackpots',
    title: 'categoriesItem.jackpots',
    new: true
  },
  tournaments: {
    path: '/tournaments',
    title: 'sidebarPages.tournaments',
    highlighted: true
  },
  loyalty: {
    path: '/vip',
    title: 'sidebarPages.loyalty'
  }
};

export const sidebarPagesList: SidebarPagesParams[] = [
  SIDEBAR_PAGES.promo,
  SIDEBAR_PAGES.jackpots,
  SIDEBAR_PAGES.tournaments,
  SIDEBAR_PAGES.loyalty
];
